import { render, staticRenderFns } from "./cjwt.vue?vue&type=template&id=0f54a9c2&scoped=true&"
import script from "./cjwt.vue?vue&type=script&lang=js&"
export * from "./cjwt.vue?vue&type=script&lang=js&"
import style0 from "./cjwt.vue?vue&type=style&index=0&id=0f54a9c2&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f54a9c2",
  null
  
)

export default component.exports